import $ from 'jquery'

window.jQuery = $
window.$ = $

export default function handleFormLabels() {
  function initFormLabelsHandler() {
    const forms = [...document.querySelectorAll('.c-form-wrap')]
    forms.forEach(form => {
      const formRows = [...form.querySelectorAll('li.gfield')]
      // Perform initial check to correctly position labels after a failed ajax request
      formRows.forEach(row => {
        const label = row.querySelector('li.gfield > .gfield_label')
        const input =
          row.querySelector('input') || row.querySelector('textarea')
        const select =
          row.querySelector('select')
        const consent =
          row.querySelector('.gfield_consent_label')
          

        if (label && input) {
          if (input.value !== '') {
            label.classList.add('js-label-focused')
          }
        }

        if (label && select) {
          label.classList.add('js-label-focused')
        }

        if (label && consent) {
          label.remove();
        }
      })

      // Add event listeners
      if (formRows) {
        formRows.forEach(row => {
          const label = row.querySelector('label')
          const input =
            row.querySelector('input') || row.querySelector('textarea')
            if (!input) {
              return;
            }
          input.addEventListener('focus', e => {
            label.classList.add('js-label-focused')
          })
          input.addEventListener('blur', e => {
            if (input.value == '') {
              label.classList.remove('js-label-focused')
            }
          })
        })
      }
    })

    // $(document).on('gform_page_loaded', function(event, form_id, current_page) {

    // })
  }



  const isPresent = document.getElementsByClassName('c-form-wrap')

  if (isPresent.length > 0) {
    initFormLabelsHandler()

    jQuery(document).on('gform_post_render', function(event, form_id, current_page){
      initFormLabelsHandler();
    });
  }
}
